import { NEW_USER, AUTHENTICATE_USER } from '../actions/index';
import _ from 'underscore';

export default function (state = {}, { type, payload }) {
    switch (type) {
        case NEW_USER:
            if(payload.data) {
                return payload.data;
            }
            break;
        case AUTHENTICATE_USER:
            if(payload.data.user) {
                const { emailAddress, id, userEmails } = payload.data.user;
                let individualEmailId = null;
                if(userEmails && emailAddress) {
                    _.forEach(userEmails, e => {
                        if(emailAddress === e.emailAddress && !e.verified) {
                            individualEmailId = e.id;
                        }
                    });
                }
                return {
                    id,
                    email: emailAddress,
                    individualEmailId
                };
            }
    }

    return state;
}
